export default __webpack_public_path__ + "static/media/HWQS.faf5f14a.png";